import { Skeleton, Stack } from "@mui/material";

export function ListSkeleton() {
  return (
    <Stack padding={1}>
      <Skeleton height={20} />
      <Skeleton height={20} />
      <Skeleton height={20} />
      <Skeleton height={20} />
    </Stack>
  );
}
